export function ChecklistListLoadingPlaceholder() {
  return (
    <div className="placeholder-glow">
      <div className="list-group list-group-flush">
        {[0, 1, 2].map((i) => (
          <div key={i} className="list-group-item d-flex justify-content-between align-items-center">
            <div className="w-100">
              <div className="placeholder col-6 mb-2" style={{ height: '1.2rem' }}></div>
              <div className="placeholder col-8" style={{ height: '1rem' }}></div>
            </div>
            <div>
              <span className="placeholder btn btn-primary" style={{ width: '100px' }}></span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
